import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Form, FormGroup } from 'reactstrap';
import Loader from '../../../common/Loader';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired } from '../../../../utils/validators';
import CountrySelect from '../../../common/forms/select/CountrySelect';
import IdentificationTypeSelect from '../../../common/forms/select/IdentificationTypeSelect';
import DatePicker from '../../../common/forms/input/DatePicker';
import FormFooter from '../../../common/forms/FormFooter';
import { tzNormalizeDate } from '../../../../utils/date';

const CustomerMinimalForm = ({
  handleSubmit,
  loading,
  initialValues,
}) => {

  if (loading) return <Loader />;

  let statusRef;

  useEffect(() => {
    if (statusRef) {
      statusRef.focus();
    }
  }, []);

  const isIdDocumentNumberDisabled = initialValues && initialValues.idDocumentNumber
  const isFirstNameDisabled = initialValues && initialValues.firstName
  const isLastNameDisabled = initialValues && initialValues.lastName
  const idCountryOfOriginDisabled = initialValues && initialValues.idCountryOfOrigin

  return (
    <Form onSubmit={null}>
      <h3>Información Básica</h3>
      <FormGroup row>
        <FormItem label="Nombres" required>
          <Field
            name="firstName"
            component={TextInput}
            type="text"
            placeholder="Nombres"
            validate={[isRequired]}
            autoFocus
            setFieldToBeFocused={(input) => {
              statusRef = input;
            }}
            disabled={isFirstNameDisabled}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Apellidos" required>
          <Field
            name="lastName"
            component={TextInput}
            type="text"
            placeholder="Apellidos"
            validate={[isRequired]}
            disabled={isLastNameDisabled}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tipo de Documento" required>
          <Field
            name="identificationTypeId"
            component={IdentificationTypeSelect}
            isClearable={false}
            validate={[isRequired]}
            placeholder="Tipo de Documento"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Núm. de Documento" required>
          <Field
            name="idDocumentNumber"
            component={TextInput}
            type="text"
            placeholder="Número de Documento"
            validate={[isRequired]}
            disabled={isIdDocumentNumberDisabled}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="País de Origen" required>
          <Field
            name="idCountryOfOrigin"
            component={CountrySelect}
            validate={[isRequired]}
            placeholder="Ingresa mínimo 4 caracteres"
            disabled={idCountryOfOriginDisabled}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Fecha de Nacimiento" required>
          <Field
            name="dateOfBirth"
            props={{
              max: tzNormalizeDate(),
            }}
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter
        saveButtonType="button"
        saveButtonAction={handleSubmit}
      />
    </Form>
  );
};

CustomerMinimalForm.propTypes = {
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    idDocumentNumber: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    identificationTypeId: PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
    idCountryOfOrigin: PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
    dateOfBirth: PropTypes.string,
  }),
};

CustomerMinimalForm.defaultProps = {
  loading: false,
  initialValues: null,
};

const mapStateToProps = ({ UserUnit }) => ({
  loading: !UserUnit.Customer.getIn(['current', 'activity']).isEmpty(),
});

const formComponent = reduxForm({
  form: 'CustomerMinimalForm',
  // validate,
})(CustomerMinimalForm);

export default connect(mapStateToProps)(formComponent);